import { render, staticRenderFns } from "./purchasePay.vue?vue&type=template&id=338a3e5a&scoped=true&"
import script from "./purchasePay.vue?vue&type=script&lang=js&"
export * from "./purchasePay.vue?vue&type=script&lang=js&"
import style0 from "./purchasePay.vue?vue&type=style&index=0&id=338a3e5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338a3e5a",
  null
  
)

export default component.exports